import { useDropzone } from 'react-dropzone';
import { WBox, WModal } from '../../wrappers/wrapper';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import styles from './dropzone-modal.module.scss';
import Button from 'components/atoms/button/button';

function DropzoneModal({
  open,
  handleClose,
  onDrop,
}: {
  open: boolean;
  handleClose: (value: boolean) => void;
  onDrop: (value: any) => void;
}) {
  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <WModal open={open} onClose={handleClose}>
      <div className={styles['modal-container']}>
        <WBox className={styles['content']}>
          <div className={styles['upload-container']} {...getRootProps()}>
            <input {...getInputProps()} />

            <div className={styles['upload-content']}>
              <CloudUploadIcon fontSize="large" />
              <div>
                <p className={styles.title}>Drop your image here to upload</p>
                <span>
                  Works with any .JPG, .PNG, or .GIF file from the web <br /> Recommended size: 300
                  x 300
                </span>
              </div>
              <Button type={'primary'} radius="2rem" onClick={() => {}}>
                Choose File
              </Button>
            </div>
          </div>
        </WBox>
      </div>
    </WModal>
  );
}

export default DropzoneModal;
